import { Typography } from '@mui/material'
import styled from 'styled-components'

export const StyledLink = styled(Typography)`
  && {
    font-weight: 700;
    font-size: 13px;
  }
`
